import React from 'react';

import { IconProps, SvgIcon } from './SvgIcon';

export function ClosedShoppingCartXL(props: IconProps): JSX.Element {
  const { ...rest } = props;

  return (
    <SvgIcon
      {...rest}
      enclosed
      name="CloseShoppingCartXL"
      size="xl"
      viewBox="0 0 128 128"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M32.5 98.8C32 98.8 31.5 98.6 31.1 98.2C30.3 97.4 30.3 96.2 31.1 95.4L95.9 30.6C96.7 29.8 97.9 29.8 98.7 30.6C99.5 31.4 99.5 32.6 98.7 33.4L33.9 98.3C33.5 98.6 33 98.8 32.5 98.8Z"
          fill="#C82121"
        />
        <path
          d="M53.0001 85C50.3001 85 48.1001 87.2 48.1001 89.9C48.1001 92.6 50.3001 94.8 53.0001 94.8C55.7001 94.8 57.9001 92.6 57.9001 89.9C57.9001 87.2 55.7001 85 53.0001 85Z"
          fill="black"
        />
        <path
          d="M80.7999 85C78.0999 85 75.8999 87.2 75.8999 89.9C75.8999 92.6 78.0999 94.8 80.7999 94.8C83.4999 94.8 85.6999 92.6 85.6999 89.9C85.6999 87.2 83.4999 85 80.7999 85Z"
          fill="black"
        />
        <path
          d="M94.6002 42L90.6002 46H95.5002L91.8002 61.2C91.4002 63.1 89.8002 64.5 87.9002 64.7L69.8002 66.8L65.2002 71.4L88.3002 68.7C91.9002 68.3 94.8002 65.7 95.7002 62.2L100.5 42H94.6002Z"
          fill="black"
        />
        <path
          d="M88.8998 77.2H59.2998L55.2998 81.2H88.8998C89.9998 81.2 90.8998 80.3 90.8998 79.2C90.8998 78.1 89.9998 77.2 88.8998 77.2Z"
          fill="black"
        />
        <path
          d="M53.8 72.7L58.4 68.1L52.6 68.8L45.1 46H80.5L84.5 42H43.8L42.2 37.2C41 33.7 37.8 31.3 34 31.3H29C27.9 31.3 27 32.2 27 33.3C27 34.4 27.9 35.3 29 35.3H34.1C36.1 35.3 37.9 36.6 38.5 38.5L49.9 73.3L53.8 72.7Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="73.5"
            height="68.8"
            fill="white"
            transform="translate(27 30)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
